export default "__VITE_ASSET__Ci0Feiu8__"